import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import { ConfigurarAgendaRoutingModule } from "./configurar-agenda-routing.module";
import { ConfigurarAgendaComponent } from "./configurar-agenda.component";
import { TableModule } from "primeng/table";
import { CheckboxModule } from "primeng/checkbox";
import { CalendarModule } from "primeng/calendar";
import { TabViewModule } from "primeng/tabview";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";

@NgModule({
    imports: [
        CommonModule,            
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        FormsModule,
        TableModule,
        CheckboxModule,
        CalendarModule,
        InputTextareaModule,
        ConfigurarAgendaRoutingModule,
        InputMaskModule,
        MessagesModule,
        TabViewModule,
        ConfirmDialogModule
    ],
    declarations: [ConfigurarAgendaComponent],
    providers: [ConfirmationService]
})
export class ConfigurarAgendaModule { }
